if (!String.prototype.toPhone) {
  // eslint-disable-next-line
  String.prototype.toPhone = function () {
    if (this.length === 12) {
      return this.replace(/(\d{4})(\d{4})(\d{4})/, '$1-$2-$3').replace(/^821/, '01');
    }
    return this;
  };
}
